// Constants
import ColumnName from '../column-name/column-name.constants';
import Kendo from '../../../constants/kendo.constants';

export default {
  columns: [
    {
      ...ColumnName.buttons,
      cell: Kendo.cellTemplateNames.buttons,
      filterable: false,
      minResizableWidth: Kendo.size.minResizableWidth,
      columnMenu: false,
      selected: true,
      width: Kendo.size.width.buttons
    },
    {
      ...ColumnName.Unit.unitId,
      filter: Kendo.filter.numeric,
      filterable: false, // isActive is just visible, it is filtered by the global filter
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: false,
      width: Kendo.size.width.default
    },
    {
      ...ColumnName.Unit.unitTypeId,
      filter: Kendo.filter.numeric,
      filterable: false,
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: false,
      width: Kendo.size.width.int,
      hideFromGrid: true
    },
    {
      ...ColumnName.Unit.suggestedInterval,
      filter: Kendo.filter.numeric,
      selected: true,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.int
    },
    {
      ...ColumnName.Unit.unitName,
      filter: Kendo.filter.text,
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: true,
      width: Kendo.size.width.default
    },
    {
      ...ColumnName.Unit.unitTypeName,
      filter: Kendo.filter.text,
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: false,
      width: Kendo.size.width.default
    },
    {
      ...ColumnName.Unit.comments,
      filter: Kendo.filter.text,
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: false,
      width: Kendo.size.width.default
    },
    {
      ...ColumnName.Unit.customerName,
      filter: Kendo.filter.text,
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: true,
      width: Kendo.size.width.default
    },
    {
      ...ColumnName.User.customerId,
      filter: Kendo.filter.numeric,
      filterable: false,
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: false,
      width: Kendo.size.width.int
    },
    {
      ...ColumnName.Unit.customerCode,
      filter: Kendo.filter.text,
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: true,
      width: Kendo.size.width.default
    },
    {
      ...ColumnName.Unit.customerComment,
      filter: Kendo.filter.text,
      filterable: false,
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: false,
      width: Kendo.size.width.int,
      hideFromGrid: true
    },
    {
      ...ColumnName.Customer.customerThirdParty,
      filter: Kendo.filter.text,
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: false,
      width: Kendo.size.width.default
    },
    {
      ...ColumnName.Unit.manufacturerModelName,
      filter: Kendo.filter.text,
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: true,
      width: Kendo.size.width.default
    },
    {
      ...ColumnName.Unit.manufacturerModelCode,
      filter: Kendo.filter.text,
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: false,
      width: Kendo.size.width.default
    },
    {
      ...ColumnName.Unit.manufacturerModelId,
      filter: Kendo.filter.numeric,
      filterable: false,
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: false,
      width: Kendo.size.width.int,
      hideFromGrid: true
    },
    {
      ...ColumnName.Unit.defaultFluidUnitOfMeasureCode,
      filter: Kendo.filter.text,
      filterable: false,
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: false,
      width: Kendo.size.width.default,
      hideFromGrid: true
    },
    {
      ...ColumnName.Unit.defaultFluidId,
      filter: Kendo.filter.numeric,
      filterable: false,
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: false,
      width: Kendo.size.width.int,
      hideFromGrid: true
    },
    {
      ...ColumnName.Unit.defaultFluidUnitOfMeasureId,
      filter: Kendo.filter.numeric,
      filterable: false,
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: false,
      width: Kendo.size.width.int,
      hideFromGrid: true
    },
    {
      ...ColumnName.Unit.defaultFluidKeywords,
      filter: Kendo.filter.text,
      filterable: false,
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: true,
      width: Kendo.size.width.default,
      hideFromGrid: false
    },
    {
      ...ColumnName.Unit.defaultFluidName,
      filter: Kendo.filter.text,
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: true,
      width: Kendo.size.width.default
    },
    {
      ...ColumnName.Unit.fluidTypeName,
      filter: Kendo.filter.text,
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: true,
      width: Kendo.size.width.default
    },
    {
      ...ColumnName.Unit.defaultReadingUnitOfMeasureId,
      filter: Kendo.filter.numeric,
      filterable: false,
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: false,
      width: Kendo.size.width.int,
      hideFromGrid: true
    },
    {
      ...ColumnName.Unit.defaultReadingUnitOfMeasureCode,
      filter: Kendo.filter.text,
      filterable: false,
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: false,
      width: Kendo.size.width.default,
      hideFromGrid: true
    },
    {
      ...ColumnName.Unit.attention,
      filter: Kendo.filter.text,
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: false,
      width: Kendo.size.width.default
    },
    {
      ...ColumnName.Unit.defaultFluidUnitOfMeasureName,
      filter: Kendo.filter.text,
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: false,
      width: Kendo.size.width.default
    },
    {
      ...ColumnName.Unit.defaultReadingUnitOfMeasureName,
      filter: Kendo.filter.text,
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: false,
      width: Kendo.size.width.default
    },
    {
      ...ColumnName.Unit.defaultFluidSearchField,
      filter: Kendo.filter.text,
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: false
    },
    {
      ...ColumnName.Unit.createdOn,
      filter: Kendo.filter.date,
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: false,
      width: Kendo.size.width.date
    },
    {
      ...ColumnName.Unit.modifiedOn,
      filter: Kendo.filter.date,
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: false,
      width: Kendo.size.width.date
    }
  ],
  doClientSide: false,
  filter: {
    logic: 'and',
    filters: []
  },
  paging: {
    pageSize: 10,
    skip: 0,
    take: 10
  },
  searchHeader: 'Search Units',
  searchPlaceholder: 'Enter keywords...',
  sort: [{ field: ColumnName.Unit.unitName.field, dir: Kendo.sort.asc }],
  title: 'Units Grid'
};
